var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-view'),_c('DocumentViewer'),_c('iframe',{staticStyle:{"display":"none"},attrs:{"id":"iframe_logout","src":""},on:{"load":_vm.logoutLoad}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }